<script>
import projectApi from '@/api/project';
import materialApi from '@/api/material';
import materialOrderApi from '@/api/materialOrder';
import materialCategoryApi from '@/api/materialCategory';
import exchangeBidApi from '@/api/exchangeBid';

import utils from '@/utils/common';

import Default from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import DecorCategorySelector from '@/components/exchange/material/MaterialCategorySelector.vue';
import MaterialOrdersPopup from '@/components/exchange/MaterialOrdersPopup.vue';
import MaterialTile from '@/components/exchange/MaterialTile.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BasePopup from '@/components/BasePopup.vue';
import ExchangeResponseForm from '@/components/exchange/ExchangeBidForm.vue';
import FormBlock from '@/components/FormBlock.vue';
import MaterialsTable from '@/components/exchange/MaterialsTable.vue';
import MaterialListFooterBar from '@/components/exchange/material/MaterialListFooterBar.vue';
import BaseInput from '@/components/BaseInput.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseSelectMulti from '@/components/BaseSelectMulti.vue';
import BaseAccordion from '@/components/BaseAccordion.vue';
import MaterialForm from '@/components/exchange/material/MaterialForm.vue';
import MaterialCategoryItemRecursive
  from '@/components/exchange/material/admin/MaterialCategoryItemRecursive.vue';

export default {
  name: 'MaterialList',
  components: {
    MaterialCategoryItemRecursive,
    MaterialForm,
    BaseAccordion,
    BaseSelectMulti,
    BaseSelect,
    BaseInput,
    MaterialListFooterBar,
    MaterialsTable,
    FormBlock,
    ExchangeResponseForm,
    MaterialOrdersPopup,
    BasePopup,
    BaseCheckbox,
    DecorCategorySelector,
    CommonSection,
    Default,
    MaterialTile,
  },
  data() {
    return {
      editableItem: null,
      isAdding: false,
      project: null,
      itemsRaw: [],
      selected: [],
      orders: [],
      bids: [],
      categories: [],
      itemIdsChecked: [],
      collapsedGroups: [],
      filters: {
        search: '',
        rooms: [],
        supplier: null,
        groupBy: null,
      },
    };
  },
  mounted() {
    this.reload();
  },
  computed: {
    items() {
      const search = this.filters.search.toLowerCase().replace(/ /g, '');
      // const roomsSet = new Set(this.filters.rooms);
      const roomsFilter = [...this.filters.rooms].sort().join();

      return this.itemsRaw
        .map(i => ({
          ...i,
          orders: i.orders.map(o => this.orders.find(oo => oo['@id'] === o)),
        }))
        .filter(i => (!search || i.name.toLowerCase().replace(/ /g, '').includes(search))
          && (!this.filters.supplier || this.filters.supplier === i.mainBid?.supplierManual?.id.toString())
          && (!this.filters.rooms.length || [...i.rooms].sort().join() === roomsFilter));
          // && (!roomsSet.size || utils.haveIntersection(roomsSet, new Set(i.rooms))));
    },
    itemsGrouped() {
      const getSupId = item => item.mainBid?.supplierManual?.id ?? 'Без поставщика';
      const itemsGrouped = Object.fromEntries(
        [...new Set(this.items.reduce((acc, val) => [...acc, getSupId(val)], []))]
          .map(id => [id, []]),
      );

      this.items.forEach(i => { itemsGrouped[getSupId(i)].push(i); });

      return itemsGrouped;
    },
    itemsChecked() {
      return this.items.filter(i => this.itemIdsChecked.includes(i.id));
    },
    roomsOptions() {
      return [...new Set(this.itemsRaw.reduce((acc, val) => [...acc, ...val.rooms], []))];
    },
    suppliersOptions() {
      return this.itemsRaw
        .reduce((acc, val) => {
          const supplier = val.mainBid?.supplierManual;
          return supplier
            ? { ...acc, [supplier.id]: supplier.name }
            : acc;
        }, []);
    },
  },
  methods: {
    reload() {
      const filter = { project: this.$route.params.projectId };
      projectApi.fetchItem(this.$route.params.projectId, true).then(r => { this.project = r; });
      materialApi.fetchList(filter, true).then(r => { this.itemsRaw = r.items; });
      materialOrderApi.fetchList(filter, true).then(r => { this.orders = r.items; });
      materialCategoryApi.fetchList({}, true).then(r => { this.categories = r.items; });
      // exchangeResponseApi.fetchList({}, true).then(r => { this.responses = r.items; });
    },
    async createCategories() {
      const parsedCats = JSON.parse('[{"name":"Автоэлектроника","children":[{"name":"GPS-навигаторы"},{"name":"Видеорегистраторы"},{"name":"Магнитолы"},{"name":"Акустика"},{"name":"Радары-детекторы"}]},{"name":"Бытовая техника","children":[{"name":"Холодильники"},{"name":"Водонагреватели"},{"name":"Микроволновые печи"}]},{"name":"Напольные покрытия","children":[{"name":"Ламинат"},{"name":"Паркетная доска"},{"name":"Плитка"},{"name":"Подложки, основания"}]},{"name":"Садовая техника","children":[{"name":"Культиваторы"},{"name":"Мотоблоки"}]},{"name":"Сантехника","children":[{"name":"Ванны"},{"name":"Душевые кабины"},{"name":"Раковины, умывальники"},{"name":"Смесители"},{"name":"Унитазы"}]},{"name":"Строительные материалы","children":[{"name":"Клеи"},{"name":"Лакокрасочные материалы"},{"name":"Сухие строительные смеси"}]},{"name":"Фото и видео","children":[{"name":"Видеокамеры"},{"name":"Объективы"},{"name":"Фотоаппараты"},{"name":"Цифровые фоторамки"}]},{"name":"Одежда","children":[{"name":"Женская одежда"},{"name":"Мужская одежда"},{"name":"Детская для девочек"},{"name":"Детская для мальчиков"}]},{"name":"Спортивные товары","children":[{"name":"Велорюкзаки"},{"name":"Велосипеды"}]},{"name":"Электроинструмент","children":[{"name":"Дрели"},{"name":"Перфораторы"},{"name":"Шуруповерты"},{"name":"Аккумуляторы"}]}]');
      const rt = await materialCategoryApi.create({ name: 'Для теста фильтра' });
      console.log(parsedCats);

      for (let l0 = 0; l0 < parsedCats.length; l0 += 1) {
        const item = parsedCats[l0];

        const rt1 = await materialCategoryApi.create({ name: item.name, parent: rt['@id'] });

        for (let l1 = 0; l1 < item.children.length; l1 += 1) {
          const subitem = item.children[l1];
          await materialCategoryApi.create({ name: subitem.name, parent: rt1['@id'] });
        }
      }

      // for(let l0 = 0; l0 < 5; l0 += 1) {
      //   const r0 = await decorCategoryApi.create({ name: `Категория ${l0 + 1}` });
      //   for(let l1 = 0; l1 < 3; l1 += 1) {
      //     const r1 = await decorCategoryApi.create({ name: `Категория ${l0 + 1}.${l1 + 1}`, parent: r0['@id'] });
      //     for(let l2 = 0; l2 < 3; l2 += 1) {
      //       const r2 = await decorCategoryApi.create({ name: `Категория ${l0 + 1}.${l1 + 1}.${l2 + 1}`, parent: r1['@id'] });
      //     }
      //   }
      // }
    },
    async del(item) {
      await materialApi.delete(item.id, true);
      this.reload();
    },
    select(id) {
      this.selected = this.selected.includes(id)
        ? this.selected.filter(i => i !== id)
        : [...this.selected, id];
    },
    async bindToOrder() {
      const res = await this.$refs.ordersPopup.open();
      if (!res) return;

      if (res.id) {
        const materials = Array.from(new Set([...res.materials, ...this.selected]));
        await materialOrderApi.update(res.id, { materials }, true);
        res.materials = materials;
      } else {
        const { name } = res;
        const project = projectApi.getIri(this.$route.params.projectId);
        const data = { name, project, status: '', materials: this.selected }; // eslint-disable-line
        const r = await materialOrderApi.create(data, true);
        this.orders.push(r);
      }

      this.reload();
      this.selected = [];
    },
    async deleteFromOrder(item, orderId) {
      const orders = item.orders.map(o => o['@id']).filter(o => o !== orderId);
      materialApi.update(item.id, { orders }, true);

      this.reload();
    },
    async createBid(material, data) {
      await exchangeBidApi.create({ ...data, material: material['@id'] }, true);
      this.reload();
    },
    async updateBid(bid) {
      await exchangeBidApi.update(bid.id, bid, true);
      this.reload();
    },
    async deleteBid(bid) {
      await exchangeBidApi.delete(bid.id, true);
      this.reload();
    },
    async setMainBid(material, bid) {
      await materialApi.update(material.id, { mainBid: bid['@id'] }, true);
      this.reload();
    },
    async unsetMainBid(material) {
      await materialApi.update(material.id, { mainBid: null }, true);
      this.reload();
    },
    async editMaterial(material = null) {
      const res = await this.$refs.materialForm.open(material);

      if (!res) return;

      if (material) {
        await materialApi.update(material.id, res, true);
      } else {
        await materialApi.create(res, true);
      }

      this.reload();
    },
    addMaterial() {
      this.editMaterial(null);
    },
    updateMaterial(material) {
      this.editMaterial(material);
    },
    materialSaved() {
      this.isAdding = false;
      this.editableItem = null;
      this.reload();
    },
    async deleteMaterial(material) {
      if (await this.$confirm(`Удаить ${material.name}?`)) {
        await materialApi.delete(material.id, true);
        this.reload();
      }
    },
    checkMaterial({ items, newState }) {
      this.itemIdsChecked = newState
        ? [...this.itemIdsChecked, ...items]
        : this.itemIdsChecked.filter(i => !items.includes(i));
    },
    toggleAllTasks() {
      this.itemIdsChecked = this.itemIdsChecked.length
        ? []
        : this.items.map(i => i.id);
    },
    update() {},
    toggleGroup(id) {
      this.collapsedGroups = (this.collapsedGroups.includes(id))
        ? this.collapsedGroups.filter(i => i !== id)
        : [...this.collapsedGroups, id];
    },
    getSupplierName(id) {
      return this.suppliersOptions[id] ?? id;
    },
  },

};
</script>

<template lang="pug">
Default(wide)
  CommonSection(title="Подбор и спецификация материалов")
    MaterialForm(:categories="categories" :project="project" ref="materialForm")
    .filters
      BaseInput(v-model="filters.search" label="Поиск")
      BaseSelect(v-model="filters.groupBy" label="Группировать по" :options="['Поставщик']")
      BaseSelectMulti(v-model="filters.rooms" label="Помещения" :options="roomsOptions")
      BaseSelect(v-model="filters.supplier" label="Поставщик" :options="suppliersOptions")
    template(v-if="categories.length")
      template(v-if="filters.groupBy")
        .tables(v-for="(itemsOfGroup, supplierId) in itemsGrouped")
          BaseAccordion(:opened="!collapsedGroups.includes(supplierId)" @toggle="toggleGroup(supplierId)" :title="getSupplierName(supplierId)")
            MaterialsTable.table(
              :items="itemsOfGroup"
              :categories="categories"
              :checked="itemIdsChecked"
              @checkMaterial="checkMaterial"
              @addMaterial="addMaterial"
              @updateMaterial="updateMaterial"
              @deleteMaterial="deleteMaterial"
              @selectBid="setMainBid($event.material, $event.bid)"
              @createBid="createBid($event.material, $event.bid)"
              @updateBid="updateBid"
              @deleteBid="deleteBid"
            )
      MaterialsTable.table(
        v-else
        :items="items"
        :categories="categories"
        :checked="itemIdsChecked"
        @checkMaterial="checkMaterial"
        @addMaterial="addMaterial"
        @updateMaterial="updateMaterial"
        @deleteMaterial="deleteMaterial"
        @selectBid="setMainBid($event.material, $event.bid)"
        @createBid="createBid($event.material, $event.bid)"
        @updateBid="updateBid"
        @deleteBid="deleteBid"
      )
  template(v-slot:footer)
    MaterialListFooterBar(:items="items" :itemsChecked="itemsChecked" @toggleAllItems="toggleAllTasks" @update="update")
</template>

<style scoped lang="scss">
.items {
  display: grid;
  gap: 30px;
}

.filters {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
}

.table {
  margin-bottom: 40px;
}
</style>
